import React,{useState} from "react";
import ReactDom from "react-dom";
import Modal from "react-modal";
import style from "../style/modal.module.css";
import MinInput from "./MinInput";
import MiniSeletor from "./MiniSeletor";

export default function ModalEdit({ isOpen, setOpen,getNome,getValor,getMes,comCampoMes,onPress}) {
  let subtitle;
  const [nome,setNome] = useState(getNome)
  const [valor,setValor] = useState(getValor)
  const [mes,setMes]= useState(getMes)

  function abriModal() {
    setOpen(true);
  }

  function handlerSalvar(){
    onPress(nome,valor,mes)
  }

  function fecharModal() {
    setOpen(false);
  }

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={fecharModal}
        className={style.content}
        contentLabel="Cuidado"
      >
        <div>
            <p className={style.label}>Nome</p>
            <MinInput
                placeholder="Digite algum valor"
                valor={nome}
                inputMask={(text) => setNome(text)}
                mask="none"
                width="500"
            />
        </div>
        <div>
            <p className={style.label}>Valor</p>
            <MinInput
                placeholder="Digite algum valor"
                valor={valor}
                inputMask={(text) => setValor(text)}
                mask="currency"
                width="500"
            />
        </div>

        {comCampoMes && 
        <div>
            <p className={style.label}>Mês</p>
            {/* <MinInput
                placeholder="Digite algum valor"
                valor={mes}
                inputMask={(text) => setMes(text)}
                mask="none"
            /> */}
            <MiniSeletor
              mes={mes}
              setMes={setMes}
            />
        </div>
        }

        <div className={style.positionbutton}>
          <button 
          className={style.button}
          onClick={handlerSalvar}>
            Alterar
          </button>
        </div>
      </Modal>
    </div>
  );
}
